import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom"
import Select, { ActionMeta, components } from "react-select";
import SwitchSelector from "react-switch-selector";
import { Flex, Text, Image, Box, Button, Heading } from "rebass/styled-components";
import { Skeleton } from "../components/loadingSkeleton/Skeleton";
import { RbCircledChecked, RbCircledUnchecked } from "../components/RadioButton";
import { GET_CARE_TEAM_CONVERSATION_ID, GET_HC_STICKY_NOTE, GET_PATIENT_BY_ID, GET_PATIENT_CHART_ALERTS } from "../graphql/queries";
import { IGetProviderPatientByIdInput, IGetProviderPatientByIdOutput, IGetProviderPatientChartAlertInput, IGetProviderPatientChartAlertOutput, IgetHealthcoachStickyNoteInput, IgetHealthcoachStickyNoteOutput } from "../graphql/types/queries/patient";
import { ReactSelectStyles } from "../styles/ReactSelectStyles";
import { Constants } from "../utils/Constants";
import { LastCourses } from "./patient/LastCourses";
import { Symptoms } from "./patient/Symptoms";
import doctorIcon from '../static/logoloader2.gif';
import { LoadingMessages } from "../components/icons/LoadingMessages";
import { getMockedFirstName, getMockedLastName } from "../utils/mocks";
import styled from "styled-components";
import ReactTooltip from "react-tooltip";
import { useRef } from "react";
import { sleep } from "../utils/sleep";
import { Surveys } from "./patient/Surveys";
import { PatientNotFoundSvg } from "./patient/components/PatientNotFoundSvg";
import PageTopBar from "./patient/components/PageTopBar";
import CommunicatorMessagerEmbedded from "./messages/components/CommunicatorMessagerEmbedded";
import KeyInfos from './patient/KeyInfos'
import LabsAndVisits from "./patient/LabsAndVisits";
import { IGetCareTeamConversationIdOutput, IGetCareTeamConversationIdInput } from "../graphql/types/queries/conversation";
import Modal from "styled-react-modal";
import { SpecialModalBackground } from "../components/Commons";
import { Form, Formik } from "formik";
import FormField from "../components/FormField";
import TextArea from "../components/TextArea";
import { APPEND_CHART_ALERT, SAVE_HC_STICKY_NOTE } from "../graphql/mutations";
import { IAppendChartAlertOutput, IAppendChartAlertInput, IaddHealthCoachStickyNoteInput, IaddHealthCoachStickyNoteOutput } from "../graphql/types/mutations/patient";
import moment from "moment";
import { B2BFreenessModal, B2BRestrictionsModal } from "./patient/components/B2BModal";
import SymptomsAndFood from "./patient/SymptomsAndFood";

const Container = styled(Flex)`
  width: 100%;
  padding-bottom: 0;
  max-width: 100%;
  max-height: 100vh;
  height: 100vh;
  overflow: 'hidden';
  @media screen and (min-width: 68.8125em) {
    padding: 0;
    padding-top: 0;
    min-width: ${() => `${Constants.OUTLETS_WIDTH}px`};
    max-width: initial;
    height: 100vh;
  }
`

const MessagesWrap = styled(Flex) <{ isExpanded: boolean }>`
  transition: all 150ms ease-in;
  max-width: 500px;
  justify-content: flex-end;
  @media screen and (max-width: 1600px) {
    position: ${(props) => props.isExpanded ? 'absolute' : 'static'};
    top:0;
    right: 0;
    z-index: 10;
  }
`

const MessagesWrapBox = styled(Flex)`
transition: all 50ms ease-in;
`


const MenuContainer = styled(Box)`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`

const MenuTrigger = styled(Box)`
  background: #4463CF;
  border-radius: 90px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  border: none;
  vertical-align: middle;
  transition: box-shadow 0.4s ease;
  margin-left: auto; /* Strictly for positioning */
  &:hover {
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.3);
  }
`

const MenuEntry = styled.div`
  padding: 17px 28px;
  background: #4463CF !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.37);
  color: white;
  &:hover {
    background: #344F7A;
  }
`
const Menu = styled(Box)`
  background: #4463CF;
  border-radius: 8px;
  position: absolute;
  top: 60px;
  right: 0;
  width: 300px;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.3);
  opacity: 0;
  z-index:1000;
  overflow: hidden;
  visibility: hidden;
  transform: translateY(-20px);
  transition: opacity 0.4s ease, transform 0.4s ease, visibility 0.4s;
  &.active {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
  }
  >${MenuEntry} {
    border-bottom: 1px solid rgba(255, 255, 255, 0.37);
    cursor: pointer;
    transition: background 0.4s ease;
  }
`

const TabsContainer = styled(Flex)`
  background: transparent;
  margin-left: ${() => `-${Constants.OUTLETS_PADDING_MOBILE}px`};
  margin-right: ${() => `-${Constants.OUTLETS_PADDING_MOBILE}px`};
  padding: ${() => `3px ${Constants.OUTLETS_PADDING_MOBILE}px`};
  height: 50px;
  min-height: 80px;
  overflow-x: auto;
  text-align: center;
  @media screen and (min-width: 68.8125em) {
  /* border: 1px solid #e0e0e0; */
    margin-left:0 !important;
    margin-right:0 !important;
    border-radius: 16px;
    padding: 3px 6px;
    overflow-x: hidden;
    min-height: 50px;
  }
`
export interface IOptionsDaysBack {
  value: number;
  label: string;
}
const optionsView = [
  {
    label: 'Labs & visits',
    value: 'Labs',
    selectedBackgroundColor: "#344F7A",
    disabled: true
  },
  {
    label: 'Key Info',
    value: 'keyInfos',
    selectedBackgroundColor: "#344F7A",
    disabled: true
  },
  {
    label: "Surveys",
    value: "surveys",
    selectedBackgroundColor: "#344F7A"
  },
  {
    label: "Courses",
    value: "courses",
    selectedBackgroundColor: "#344F7A"
  },
  {
    label: 'Symptoms',
    value: 'symptoms',
    selectedBackgroundColor: "#344F7A",
    disabled: true
  },
];

const Option = (props: any) => {
  return (
    <components.Option {...props}>
      <Flex alignItems={'center'}>
        {props.isSelected ? (
          <RbCircledChecked />
        ) : <RbCircledUnchecked />}

        <Text ml={2}>{props.children}</Text>
      </Flex>
    </components.Option>
  );
};

export const PatientInner = ({ id }: { id: string }) => {
  const chartAlertRef = useRef<any>(null)
  const [isExpanded, setisExpanded] = useState<boolean>(false);
  const [isAlertOpen, setIsAlertOpen] = useState(false)
  const [isEditAlert, setIsEditAlert] = useState(false)
  const [isEditHcSticky, setEditHcSticky] = useState(false)
  const [isShowB2B, setIsShowB2B] = useState(false)
  const [appendChartAlert, { loading: loadingAppendChartAlert }] = useMutation<IAppendChartAlertOutput, IAppendChartAlertInput>(APPEND_CHART_ALERT)

  const { data, loading, error, refetch: refetchChartAlerts } = useQuery<IGetProviderPatientChartAlertOutput, IGetProviderPatientChartAlertInput>(GET_PATIENT_CHART_ALERTS, {
    variables: {
      id
    },
    onCompleted: async (a) => {
      await sleep(300)
      ReactTooltip.rebuild()
      if (!a || !a.getProviderPatientChartAlert || !a.getProviderPatientChartAlert.notetext) {
        ReactTooltip.hide(chartAlertRef.current)

      } else {
        ReactTooltip.show(chartAlertRef.current)
      }
    }
  })
  const [addHcStickyNote, { loading: loadingAddHcStickyNote }] = useMutation<IaddHealthCoachStickyNoteOutput, IaddHealthCoachStickyNoteInput>(SAVE_HC_STICKY_NOTE)
  const HcStickyNoteRef = useRef<any>(null)
  const { data: dataHealthcoachStickyNote, loading: loadingHealthcoachStickyNote, error: errorHealthcoachStickyNote, refetch: refetchHealthcoachStickyNote } = useQuery<IgetHealthcoachStickyNoteOutput, IgetHealthcoachStickyNoteInput>(GET_HC_STICKY_NOTE, {
    variables: {
      id
    },
    onCompleted: async (a) => {
      await sleep(300)
      ReactTooltip.rebuild()
      // if (!a || !a.getProviderPatientChartAlert || !a.getProviderPatientChartAlert.notetext) {
      //   ReactTooltip.hide(chartAlertRef.current)

      // } else {
      //   ReactTooltip.show(chartAlertRef.current)
      // }
    }
  })
  const [selectedView, setselectedView] = useState<'Labs' | 'keyInfos' | 'symptoms' | 'courses' | 'surveys'>('Labs');

  const [loadPatient, { data: dataPatient, loading: loadingPatient, error: errorPatient }] = useLazyQuery<IGetProviderPatientByIdOutput, IGetProviderPatientByIdInput>(GET_PATIENT_BY_ID)


  useEffect(() => {
    if (!id) return
    loadPatient({
      variables: {
        id
      }
    })
    setselectedView('Labs')
  }, [id])

  useEffect(() => {
    if (data && data.getProviderPatientChartAlert && data.getProviderPatientChartAlert.notetext) {
      ReactTooltip.rebuild()

      ReactTooltip.show(chartAlertRef.current)
    } else {
      ReactTooltip.hide(chartAlertRef.current)
    }
  }, [data, dataPatient])
  if (!id) return null
  if (loadingPatient) return (
    <Container flexDirection={'column'} style={{ height: '100%' }}>
      <Flex mb={4} alignItems='center' mt={`${Constants.OUTLETS_PADDING_TOP}px`}>
        <Box display={['none!important', 'flex', 'flex']}><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M33.5353 29.8281C32.7984 28.0827 31.729 26.4973 30.3868 25.1602C29.0487 23.8192 27.4635 22.75 25.7188 22.0117C25.7032 22.0039 25.6876 22 25.672 21.9922C28.1056 20.2344 29.6876 17.3711 29.6876 14.1406C29.6876 8.78906 25.3517 4.45312 20.0001 4.45312C14.6485 4.45312 10.3126 8.78906 10.3126 14.1406C10.3126 17.3711 11.8946 20.2344 14.3282 21.9961C14.3126 22.0039 14.297 22.0078 14.2813 22.0156C12.5313 22.7539 10.961 23.8125 9.61338 25.1641C8.2724 26.5022 7.20324 28.0874 6.46494 29.832C5.73964 31.5401 5.34846 33.3713 5.3126 35.2266C5.31156 35.2683 5.31887 35.3097 5.3341 35.3486C5.34934 35.3874 5.3722 35.4228 5.40132 35.4526C5.43044 35.4825 5.46524 35.5062 5.50368 35.5224C5.54211 35.5386 5.58339 35.5469 5.6251 35.5469H7.96885C8.14072 35.5469 8.27744 35.4102 8.28135 35.2422C8.35947 32.2266 9.57041 29.4023 11.711 27.2617C13.9259 25.0469 16.8673 23.8281 20.0001 23.8281C23.1329 23.8281 26.0743 25.0469 28.2892 27.2617C30.4298 29.4023 31.6407 32.2266 31.7188 35.2422C31.7228 35.4141 31.8595 35.5469 32.0313 35.5469H34.3751C34.4168 35.5469 34.4581 35.5386 34.4965 35.5224C34.535 35.5062 34.5698 35.4825 34.5989 35.4526C34.628 35.4228 34.6509 35.3874 34.6661 35.3486C34.6813 35.3097 34.6886 35.2683 34.6876 35.2266C34.6485 33.3594 34.2618 31.543 33.5353 29.8281ZM20.0001 20.8594C18.2071 20.8594 16.5196 20.1602 15.2501 18.8906C13.9806 17.6211 13.2813 15.9336 13.2813 14.1406C13.2813 12.3477 13.9806 10.6602 15.2501 9.39062C16.5196 8.12109 18.2071 7.42188 20.0001 7.42188C21.7931 7.42188 23.4806 8.12109 24.7501 9.39062C26.0196 10.6602 26.7188 12.3477 26.7188 14.1406C26.7188 15.9336 26.0196 17.6211 24.7501 18.8906C23.4806 20.1602 21.7931 20.8594 20.0001 20.8594Z" fill="#344F7A" />
        </svg></Box>
        <Skeleton height={36} width={250} style={{ marginLeft: '12px' }} />
      </Flex>
      <Flex flex={1} flexDirection={'column'} justifyContent='center' alignItems={'center'} >
        <LoadingMessages style={{ maxWidth: '50%' }} />
      </Flex>
    </Container>
  )
  if (!dataPatient || !dataPatient.getProviderPatientById) {
    return (<Container flexDirection={'column'}
      justifyContent='center'
      alignItems={'center'}
      style={{ height: '100%' }}>
      <Flex mt={`${Constants.OUTLETS_PADDING_TOP}px`} style={{ position: 'relative' }}>
        <Flex style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          justifyContent: 'center',
          alignItems: 'center',
        }}>
          <Image src={doctorIcon} style={{ marginTop: '-180px', opacity: 0.5, marginRight: '-100px' }} width='80px' height='80px' />
        </Flex>
        <PatientNotFoundSvg />
      </Flex>
      <Text fontSize={'36px'} fontWeight={600}>Ups!... no results found</Text>
      <Text fontSize={'24px'}>Patient {id} does not exist</Text>
    </Container>)
  }
  let patientName = `${dataPatient?.getProviderPatientById?.firstname} ${dataPatient?.getProviderPatientById?.lastname}`
  if (Constants.IS_SCRAMBLING_MODE) {
    patientName = `${getMockedFirstName()} ${getMockedLastName()}`
  }
  const toggleExpanded = () => {
    setisExpanded(!isExpanded)
  }
  return (
    <Container id='aall' flexDirection={'row'} style={{ width: '100%', minHeight: '100%', overflow: 'hidden' }}>
      <Flex flexDirection={'column'} width={isExpanded ? 'calc(100% - 510px)' : '100%'} overflow={'hidden'}>
        {/* style={{ width: 'calc(100% - 500px)' }}> */}
        <Flex mb={[2, 4, 4]} mt={3} flexDirection={['column', 'row', 'row']}>
          <Box display={['none!important', 'flex !important', 'flex !important']}>
            {!!dataPatient && dataPatient.getProviderPatientById && dataPatient.getProviderPatientById.b2b ? (
              <svg style={{ cursor: 'pointer' }} onClick={() => setIsShowB2B(true)} width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 14C14.764 14 17 11.762 17 9C17 6.238 14.764 4 12 4C9.236 4 7 6.238 7 9C7 11.762 9.236 14 12 14ZM12 6C13.654 6 15 7.346 15 9C15 10.654 13.654 12 12 12C10.346 12 9 10.654 9 9C9 7.346 10.346 6 12 6ZM20 15C20.663 15 21.2989 14.7366 21.7678 14.2678C22.2366 13.7989 22.5 13.163 22.5 12.5C22.5 11.837 22.2366 11.2011 21.7678 10.7322C21.2989 10.2634 20.663 10 20 10C19.337 10 18.7011 10.2634 18.2322 10.7322C17.7634 11.2011 17.5 11.837 17.5 12.5C17.5 13.163 17.7634 13.7989 18.2322 14.2678C18.7011 14.7366 19.337 15 20 15ZM20 11C20.827 11 21.5 11.673 21.5 12.5C21.5 13.327 20.827 14 20 14C19.173 14 18.5 13.327 18.5 12.5C18.5 11.673 19.173 11 20 11ZM20 15.59C18.669 15.59 17.668 15.996 17.083 16.559C15.968 15.641 14.205 15 12 15C9.734 15 8.005 15.648 6.908 16.564C6.312 15.999 5.3 15.589 4 15.589C1.812 15.589 0.5 16.68 0.5 17.772C0.5 18.317 1.812 18.864 4 18.864C4.604 18.864 5.146 18.813 5.623 18.731L5.583 19.001C5.583 20.001 7.988 21.001 12 21.001C15.762 21.001 18.417 20.001 18.417 19.001L18.396 18.746C18.859 18.819 19.392 18.864 20 18.864C22.051 18.864 23.5 18.317 23.5 17.772C23.5 16.68 22.127 15.59 20 15.59ZM4 17.863C2.691 17.863 1.932 17.656 1.583 17.509C1.822 17.104 2.586 16.589 4 16.589C5.107 16.589 5.837 16.94 6.208 17.295L5.973 17.639C5.521 17.758 4.865 17.863 4 17.863ZM12 19C9.837 19 8.499 18.688 7.816 18.439C8.337 17.761 9.734 17 12 17C14.169 17 15.59 17.761 16.148 18.425C15.393 18.695 13.986 19 12 19ZM20 17.863C19.086 17.863 18.454 17.76 18.027 17.65C17.9526 17.5197 17.8698 17.3944 17.779 17.275C18.135 16.93 18.85 16.59 20 16.59C21.324 16.59 22.141 17.091 22.404 17.501C22.014 17.664 21.199 17.863 20 17.863ZM4 15C4.66304 15 5.29893 14.7366 5.76777 14.2678C6.23661 13.7989 6.5 13.163 6.5 12.5C6.5 11.837 6.23661 11.2011 5.76777 10.7322C5.29893 10.2634 4.66304 10 4 10C3.33696 10 2.70107 10.2634 2.23223 10.7322C1.76339 11.2011 1.5 11.837 1.5 12.5C1.5 13.163 1.76339 13.7989 2.23223 14.2678C2.70107 14.7366 3.33696 15 4 15ZM4 11C4.827 11 5.5 11.673 5.5 12.5C5.5 13.327 4.827 14 4 14C3.173 14 2.5 13.327 2.5 12.5C2.5 11.673 3.173 11 4 11Z" fill="#344F7A" />
              </svg>
            ) : (
              <svg width="32" height="32" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M33.5353 29.8281C32.7984 28.0827 31.729 26.4973 30.3868 25.1602C29.0487 23.8192 27.4635 22.75 25.7188 22.0117C25.7032 22.0039 25.6876 22 25.672 21.9922C28.1056 20.2344 29.6876 17.3711 29.6876 14.1406C29.6876 8.78906 25.3517 4.45312 20.0001 4.45312C14.6485 4.45312 10.3126 8.78906 10.3126 14.1406C10.3126 17.3711 11.8946 20.2344 14.3282 21.9961C14.3126 22.0039 14.297 22.0078 14.2813 22.0156C12.5313 22.7539 10.961 23.8125 9.61338 25.1641C8.2724 26.5022 7.20324 28.0874 6.46494 29.832C5.73964 31.5401 5.34846 33.3713 5.3126 35.2266C5.31156 35.2683 5.31887 35.3097 5.3341 35.3486C5.34934 35.3874 5.3722 35.4228 5.40132 35.4526C5.43044 35.4825 5.46524 35.5062 5.50368 35.5224C5.54211 35.5386 5.58339 35.5469 5.6251 35.5469H7.96885C8.14072 35.5469 8.27744 35.4102 8.28135 35.2422C8.35947 32.2266 9.57041 29.4023 11.711 27.2617C13.9259 25.0469 16.8673 23.8281 20.0001 23.8281C23.1329 23.8281 26.0743 25.0469 28.2892 27.2617C30.4298 29.4023 31.6407 32.2266 31.7188 35.2422C31.7228 35.4141 31.8595 35.5469 32.0313 35.5469H34.3751C34.4168 35.5469 34.4581 35.5386 34.4965 35.5224C34.535 35.5062 34.5698 35.4825 34.5989 35.4526C34.628 35.4228 34.6509 35.3874 34.6661 35.3486C34.6813 35.3097 34.6886 35.2683 34.6876 35.2266C34.6485 33.3594 34.2618 31.543 33.5353 29.8281ZM20.0001 20.8594C18.2071 20.8594 16.5196 20.1602 15.2501 18.8906C13.9806 17.6211 13.2813 15.9336 13.2813 14.1406C13.2813 12.3477 13.9806 10.6602 15.2501 9.39062C16.5196 8.12109 18.2071 7.42188 20.0001 7.42188C21.7931 7.42188 23.4806 8.12109 24.7501 9.39062C26.0196 10.6602 26.7188 12.3477 26.7188 14.1406C26.7188 15.9336 26.0196 17.6211 24.7501 18.8906C23.4806 20.1602 21.7931 20.8594 20.0001 20.8594Z" fill="#344F7A" />
              </svg>
            )}
          </Box>

          <PageTopBar
            isMessagesExpanded={isExpanded}
            data={data}
            dataPatient={dataPatient}
            patientName={patientName}
            chartAlertRef={chartAlertRef}
            HcStickyNoteRef={HcStickyNoteRef}
            dataHealthcoachStickyNote={dataHealthcoachStickyNote}
            createChartAlert={() => setIsEditAlert(true)}
            createHcSticky={() => setEditHcSticky(true)} />

        </Flex>

        <TabsContainer mb={4}>
          <Box minWidth={['1000px', '100%', '100%']} paddingBottom={['8px', 'initial', 'initial']} >
            <SwitchSelector
              onChange={(val) => {
                setselectedView(val as 'Labs' | 'keyInfos' | 'symptoms' | 'courses' | 'surveys')
              }}
              name='ssSelectedView'
              options={optionsView}
              initialSelectedIndex={0}
              backgroundColor={"transparent"}
              fontColor={"#344F7A"}
              selectedFontColor={"white"}
              selectedBackgroundColor={"#344F7A"}
              forcedSelectedIndex={optionsView.findIndex(x => x.value === selectedView)}
            />
          </Box>
        </TabsContainer>

        <Flex flex={1} paddingBottom={'12px'} overflowY={selectedView === 'courses' || selectedView === 'symptoms' ? 'hidden' : 'initial'}>
          {selectedView === 'Labs' && (
            <Flex flex={1} id='ttt' flexDirection={'column'} mr={[0, 4, 4]} width='100%' height={'calc(100% - 30px)'}>
              <LabsAndVisits id={id} />
            </Flex>
          )}
          {selectedView === 'keyInfos' && (
            <Flex flex={1} id='ttt' flexDirection={'column'} mr={[0, 4, 4]} width='100%' height={'calc(100% - 30px)'}>
              <KeyInfos id={id} />
            </Flex>
          )}
          {selectedView === 'surveys' && (
            <>
              <Flex flex={1} id='ttt' flexDirection={'column'} mr={[0, 0, 4]} height={'calc(100% - 1px)'}>
                {!id ? null :
                  <Surveys id={id} />}
              </Flex>
            </>
          )}
          {selectedView === 'symptoms' && (
            <Flex flex={1} id='ttt' flexDirection={'column'} mr={[0, 0, 4]} width='100%' overflow={'hidden'}>
              <SymptomsAndFood id={id} />
            </Flex>
          )}
          {selectedView === 'courses' && (
            <>
              <Flex flex={1} id='ttt' flexDirection={'column'} mr={[0, 0, 4]} width='100%' overflow={'hidden'}>
                <LastCourses id={id} isMobileUser={dataPatient.getProviderPatientById.isMobileUser} />
              </Flex>
            </>
          )}

        </Flex>

        <Flex display={['none', 'initial', 'initial']}>
          <>
            {((data || {}).getProviderPatientChartAlert || {}).notetext && (
              <ReactTooltip id='chartAlertTooltip'
                clickable={true} isCapture
                globalEventOff={"click scroll"} className='chartAlertTooltip-color' place='bottom' border={true} effect={'solid'}
                backgroundColor='#fef7d9' borderColor='#ffe781' arrowColor='#fef7d9'>
                <Flex flexDirection={'column'} minWidth={['50px', '200px', '200px']} paddingY={3} onClick={() => {
                  ReactTooltip.rebuild()
                  ReactTooltip.hide(chartAlertRef.current)
                }}>
                  <Flex>
                    <Flex flexDirection={'column'} flex={1}>
                      {((data || {}).getProviderPatientChartAlert || {}).notetext?.split('\n').map(x => {
                        return <Text color={'#344F7A'} fontSize='14px'>⊛ {x}</Text>
                      })}
                    </Flex>
                    <Text fontWeight={300} ml={2} color={'#344F7A'} fontSize='12px' style={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={() => setIsEditAlert(true)}>Edit</Text>
                  </Flex>
                  <Flex flexWrap={'wrap'} mt={2}>
                    <Text mr={2} fontWeight={300} color={'#344F7A'} opacity={0.7}>{((data || {}).getProviderPatientChartAlert || {}).lastmodifiedby}</Text>
                    <Text fontWeight={300} color={'#344F7A'} opacity={0.7}>{((data || {}).getProviderPatientChartAlert || {}).lastmodified}</Text>
                  </Flex>
                </Flex>
              </ReactTooltip>)}


            {((dataHealthcoachStickyNote || {}).getHealthcoachStickyNote || {}).note && (
              <ReactTooltip id='HcStickyNoteRefTooltip'
                clickable={true} isCapture
                globalEventOff={"click scroll"} className='chartAlertTooltip-color' place='bottom' border={true} effect={'solid'}
                backgroundColor='#d9fede' borderColor='#81ff8e' arrowColor='#d9fedb'>
                <Flex flexDirection={'column'} minWidth={['50px', '200px', '200px']} paddingY={3} onClick={() => {
                  ReactTooltip.rebuild()
                  ReactTooltip.hide(HcStickyNoteRef.current)
                }}>
                  <Flex>
                    <Flex flexDirection={'column'} flex={1}>
                      {((dataHealthcoachStickyNote || {}).getHealthcoachStickyNote || {}).note?.split('\n').map(x => {
                        return <Text color={'#344F7A'} fontSize='14px'>⊛ {x}</Text>
                      })}
                    </Flex>
                    <Text fontWeight={300} ml={2} color={'#344F7A'} fontSize='12px' style={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={() => setEditHcSticky(true)}>Edit</Text>
                  </Flex>
                </Flex>
              </ReactTooltip>)}
          </>
        </Flex>
      </Flex>
      {!!dataPatient.getProviderPatientById.helpscoutId && (
        <MessagesWrap minWidth={'40px'} isExpanded={isExpanded}>
          <Box onClick={toggleExpanded} style={{ cursor: 'pointer', backgroundColor: '#F8A294', borderRadius: '10px 0 0 10px', marginTop: '30px', position: isExpanded ? 'relative' : 'absolute', right: 0, display: 'flex', alignSelf: 'flex-start', justifyContent: 'center', alignItems: 'center', padding: '4px' }}>
            {!isExpanded ? (
              <svg width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.403 16.026L10.043 15.916C10.167 15.894 10.315 15.862 10.486 15.818C12.6 15.288 14 13.708 14 12C14 9.865 11.824 8 9 8C6.176 8 4 9.865 4 12C4 13.218 4.702 14.378 5.931 15.15L5.967 15.17L7 15.74V18.503L9.403 16.026ZM10.385 17.886L6.718 21.666C6.57942 21.809 6.40132 21.9073 6.20651 21.9484C6.0117 21.9895 5.80905 21.9715 5.62452 21.8968C5.43999 21.822 5.28197 21.6939 5.17071 21.5288C5.05945 21.3637 5.00001 21.1691 5 20.97V16.92C4.95533 16.8959 4.91131 16.8705 4.868 16.844C3.129 15.752 2 13.989 2 12C2 8.686 5.134 6 9 6C12.866 6 16 8.686 16 12C16 14.726 13.879 17.028 10.974 17.758C10.7793 17.8079 10.5828 17.8506 10.385 17.886ZM8.936 5C10.146 3.207 12.41 2 15 2C18.866 2 22 4.686 22 8C22 9.989 20.87 11.752 19.132 12.844C19.0887 12.8705 19.0447 12.8959 19 12.92V16.97C19 17.1691 18.9405 17.3637 18.8293 17.5288C18.718 17.6939 18.56 17.822 18.3755 17.8968C18.1909 17.9715 17.9883 17.9895 17.7935 17.9484C17.5987 17.9073 17.4206 17.809 17.282 17.666L15.547 15.878L16.59 14.08L17 14.503V11.74L18.033 11.17L18.069 11.15C19.299 10.378 20 9.218 20 8C20 5.865 17.824 4 15 4C13.72 4 12.574 4.383 11.703 5H8.936Z" fill="white" />
              </svg>
            ) : (
              <svg width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.41 6L5 7.41L9.58 12L5 16.59L6.41 18L12.41 12L6.41 6Z" fill="white" />
                <path d="M12.9998 6L11.5898 7.41L16.1698 12L11.5898 16.59L12.9998 18L18.9998 12L12.9998 6Z" fill="white" />
              </svg>
            )}

          </Box>
          <MessagesWrapBox style={{ height: '100vh', flex: 1, padding: '12px 0 12px 0', position: 'sticky', top: 0, maxWidth: isExpanded ? '' : 0, width: isExpanded ? '' : 0, minWidth: isExpanded ? '' : 0, overflow: 'hidden' }}>
            <CommunicatorEmbedding athenaId={id} helpscoutId={dataPatient.getProviderPatientById.helpscoutId.toString()} />
          </MessagesWrapBox>
        </MessagesWrap>)}
      {!!isEditAlert && (
        <Modal
          isOpen={true}
          onBackgroundClick={() => {
            setIsEditAlert(false)
          }}
          onEscapeKeydown={() => {
            setIsEditAlert(false)
          }}
        >
          <SpecialModalBackground
            onClick={() => {
              setIsEditAlert(false)
            }}
          >
            <Box
              style={{
                margin: '0 auto',
                alignSelf: 'center',
                borderRadius: '20px',
                position: 'relative',
                background: 'linear-gradient(180deg, #BBD4ED 0%, #FDF5F2 100%)',
                padding: '24px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                maxWidth: '95vw',
                minWidth: 'initial',
                maxHeight: '95vh',
                overflowY: 'hidden',
              }}
              onClick={(e) => {
                // e.preventDefault();
                e.stopPropagation();
              }}
            >
              <Flex flex={1} flexDirection={'column'} width={'800px'} style={{ overflowY: 'auto' }}>
                <Formik
                  initialValues={{
                    alert: ''
                  }}
                  isInitialValid={() => {
                    return true
                  }}
                  onSubmit={async (values) => {
                    await appendChartAlert({
                      variables: {
                        athenaId: id,
                        noteToAdd: values.alert
                      }
                    })
                    refetchChartAlerts()
                    setIsEditAlert(false)
                  }}
                >
                  {({ touched, errors, isValid, values, submitForm }) => {
                    return (
                      <>
                        <Form>
                          <Heading textAlign={'center'} mb={4}>Add New Sticky Note Entry</Heading>
                          <FormField mb={3} error={touched.alert && errors.alert}>
                            <TextArea style={{ minHeight: '200px', maxHeight: '200px' }} name="alert" id="input_name" />
                          </FormField>
                          <Flex alignItems="center" flexDirection="row" justifyContent={'center'}>
                            <Button variant="outline" width={'100px'} mr={3} type="button" id="btn_login" onClick={() => setIsEditAlert(false)}>
                              Cancel
                            </Button>
                            <Button disabled={!isValid || !!loadingAppendChartAlert} variant="primary" width={'100px'} type="button" id="btn_login" onClick={submitForm}>
                              Save
                            </Button>
                          </Flex>
                        </Form>

                      </>
                    );
                  }}
                </Formik>
              </Flex>
            </Box>
          </SpecialModalBackground>
        </Modal>
      )}
      {!!isEditHcSticky && (
        <Modal
          isOpen={true}
          onBackgroundClick={() => {
            setEditHcSticky(false)
          }}
          onEscapeKeydown={() => {
            setEditHcSticky(false)
          }}
        >
          <SpecialModalBackground
            onClick={() => {
              setEditHcSticky(false)
            }}
          >
            <Box
              style={{
                margin: '0 auto',
                alignSelf: 'center',
                borderRadius: '20px',
                position: 'relative',
                background: 'linear-gradient(180deg, #BBD4ED 0%, #FDF5F2 100%)',
                padding: '24px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                maxWidth: '95vw',
                minWidth: 'initial',
                maxHeight: '95vh',
                overflowY: 'hidden',
              }}
              onClick={(e) => {
                // e.preventDefault();
                e.stopPropagation();
              }}
            >
              <Flex flex={1} flexDirection={'column'} width={'800px'} style={{ overflowY: 'auto' }}>
                <Formik
                  initialValues={{
                    alert: dataHealthcoachStickyNote?.getHealthcoachStickyNote?.note
                  }}
                  isInitialValid={() => {
                    return true
                  }}
                  onSubmit={async (values) => {
                    await addHcStickyNote({
                      variables: {
                        athenaId: id,
                        note: values.alert
                      }
                    })
                    refetchHealthcoachStickyNote()
                    setEditHcSticky(false)
                  }}
                >
                  {({ touched, errors, isValid, values, submitForm }) => {
                    return (
                      <>
                        <Form>
                          <Heading textAlign={'center'} mb={4}>Add New HC Sticky Note Entry</Heading>
                          <FormField mb={3} error={touched.alert && errors.alert}>
                            <TextArea style={{ minHeight: '200px', maxHeight: '200px' }} name="alert" id="input_name" />
                          </FormField>
                          <Flex alignItems="center" flexDirection="row" justifyContent={'center'}>
                            <Button variant="outline" width={'100px'} mr={3} type="button" id="btn_login" onClick={() => setEditHcSticky(false)}>
                              Cancel
                            </Button>
                            <Button disabled={!isValid || !!loadingAddHcStickyNote} variant="primary" width={'100px'} type="button" id="btn_login" onClick={submitForm}>
                              Save
                            </Button>
                          </Flex>
                        </Form>

                      </>
                    );
                  }}
                </Formik>
              </Flex>
            </Box>
          </SpecialModalBackground>
        </Modal>
      )}
      {!!isShowB2B && dataPatient && dataPatient.getProviderPatientById && dataPatient.getProviderPatientById.b2b && (
        <Modal
          isOpen={true}
          onBackgroundClick={() => {
            setIsShowB2B(false)
          }}
          onEscapeKeydown={() => {
            setIsShowB2B(false)
          }}
        >
          <SpecialModalBackground
            onClick={() => {
              setIsShowB2B(false)
            }}
          >
            <Box
              style={{
                margin: '0 auto',
                alignSelf: 'center',
                borderRadius: '20px',
                position: 'relative',
                background: 'linear-gradient(180deg, #BBD4ED 0%, #FDF5F2 100%)',
                padding: '24px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                maxWidth: '95vw',
                minWidth: 'initial',
                maxHeight: '95vh',
                overflowY: 'hidden',
              }}
              onClick={(e) => {
                // e.preventDefault();
                e.stopPropagation();
              }}
            >
              <Flex flex={1} flexDirection={'column'} width={'800px'} style={{ overflowY: 'auto' }}>
                <Heading mb={4}>B2B User</Heading>

                <Text mb={2}>
                  Company:
                  <span style={{ fontWeight: 600 }}>{` ${dataPatient.getProviderPatientById.b2b.company}`}</span>
                </Text>
                <Text mb={2}>
                  Needs Admin Approval:
                  <span style={{ fontWeight: 600 }}>{` ${dataPatient.getProviderPatientById.b2b.needAdminApproval ? 'Yes' : 'No'}`}</span>
                </Text>
                <Text mb={2}>
                  Activation Date:
                  <span style={{ fontWeight: 600 }}>{` ${dataPatient.getProviderPatientById.b2b.activationDate ? moment(dataPatient.getProviderPatientById.b2b.activationDate).format('MM/DD/YYYY') : 'Not Activated'}`}</span>
                </Text>
                <Text mb={2}>
                  Is Active:
                  <span style={{ fontWeight: 600 }}>{` ${dataPatient.getProviderPatientById.b2b.isActive ? 'Yes' : 'No'}`}</span>
                </Text>
                <Text mb={2}>
                  Verification sent:
                  <span style={{ fontWeight: 600 }}>{` ${dataPatient.getProviderPatientById.b2b.verificationSent ? 'Yes' : 'No'}`}</span>
                </Text>
                {dataPatient.getProviderPatientById.b2b.verificationSentDate && (
                  <Text mb={2}>
                    Verification sent date:
                    <span style={{ fontWeight: 600 }}>{` ${moment(dataPatient.getProviderPatientById.b2b.verificationSentDate).format('MM/DD/YYYY')}`}</span>
                  </Text>
                )}
                {dataPatient.getProviderPatientById?.b2b?.companyId && (
                  <>
                    <B2BFreenessModal patient={dataPatient.getProviderPatientById} />
                    <B2BRestrictionsModal patient={dataPatient.getProviderPatientById} />
                  </>
                )}
                <Button alignSelf={'center'} mt={4} variant={'primary'} onClick={() => setIsShowB2B(false)}>Close</Button>
              </Flex>
            </Box>
          </SpecialModalBackground>
        </Modal>
      )}
    </Container>
  )
}

const CommunicatorEmbedding: React.FC<{
  athenaId: string,
  helpscoutId: string
}> = ({ athenaId, helpscoutId }) => {
  const { data, loading, error } = useQuery<IGetCareTeamConversationIdOutput, IGetCareTeamConversationIdInput>(GET_CARE_TEAM_CONVERSATION_ID, {
    variables: {
      helpscoutId
    }
  })

  if (!!loading) {
    return (
      <Box style={{ height: '100%', background: '#C0CDEC', flex: 1, borderRadius: '20px', paddingTop: '20px', maxWidth: '460px', minWidth: '460px', width: '460px' }}>
        <Flex flex={1} marginTop={4} width='100%' height='100%' flexDirection={'column'} justifyContent='center' alignItems={'center'} >
          <LoadingMessages style={{ maxWidth: '50%' }} />
        </Flex>
      </Box>)
  }

  return (
    <CommunicatorMessagerEmbedded athenaId={athenaId} conversationId={data?.healthCoachGetCareTeamConversationId} />
  )
}



export const PatientInnerMinimized = ({ id }: { id: string }) => {
  const chartAlertRef = useRef<any>(null)
  const [isEditAlert, setIsEditAlert] = useState(false)
  const [isEditHcSticky, setEditHcSticky] = useState(false)
  const [isShowB2B, setIsShowB2B] = useState(false)
  const [appendChartAlert, { loading: loadingAppendChartAlert }] = useMutation<IAppendChartAlertOutput, IAppendChartAlertInput>(APPEND_CHART_ALERT)
  const { data, loading, error, refetch: refetchChartAlerts } = useQuery<IGetProviderPatientChartAlertOutput, IGetProviderPatientChartAlertInput>(GET_PATIENT_CHART_ALERTS, {
    variables: {
      id
    },
    onCompleted: async (a) => {
      await sleep(300)
      ReactTooltip.rebuild()

      if (!a || !a.getProviderPatientChartAlert || !a.getProviderPatientChartAlert.notetext) {
        ReactTooltip.hide(chartAlertRef.current)

      } else {
        ReactTooltip.show(chartAlertRef.current)
      }
    }
  })

  const [addHcStickyNote, { loading: loadingAddHcStickyNote }] = useMutation<IaddHealthCoachStickyNoteOutput, IaddHealthCoachStickyNoteInput>(SAVE_HC_STICKY_NOTE)
  const HcStickyNoteRef = useRef<any>(null)
  const { data: dataHealthcoachStickyNote, loading: loadingHealthcoachStickyNote, error: errorHealthcoachStickyNote, refetch: refetchHealthcoachStickyNote } = useQuery<IgetHealthcoachStickyNoteOutput, IgetHealthcoachStickyNoteInput>(GET_HC_STICKY_NOTE, {
    variables: {
      id
    },
    onCompleted: async (a) => {
      await sleep(300)
      ReactTooltip.rebuild()
    }
  })
  const [selectedView, setselectedView] = useState<'Labs' | 'keyInfos' | 'symptoms' | 'courses' | 'surveys'>('Labs');

  const [loadPatient, { data: dataPatient, loading: loadingPatient, error: errorPatient }] = useLazyQuery<IGetProviderPatientByIdOutput, IGetProviderPatientByIdInput>(GET_PATIENT_BY_ID)

  useEffect(() => {
    if (!id) return
    loadPatient({
      variables: {
        id
      }
    })
    setselectedView('Labs')
  }, [id])

  useEffect(() => {
    if (data && data.getProviderPatientChartAlert) {
      ReactTooltip.rebuild()
    }
  }, [data, dataPatient])

  if (!id) return null
  if (loadingPatient) return (
    <Container flexDirection={'column'} style={{ width: '100%', minHeight: '100%', overflow: 'hidden' }}>
      <Flex mb={4} alignItems='center' mt={`${Constants.OUTLETS_PADDING_TOP}px`}>
        <Box display={['none!important', 'flex', 'flex']}><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M33.5353 29.8281C32.7984 28.0827 31.729 26.4973 30.3868 25.1602C29.0487 23.8192 27.4635 22.75 25.7188 22.0117C25.7032 22.0039 25.6876 22 25.672 21.9922C28.1056 20.2344 29.6876 17.3711 29.6876 14.1406C29.6876 8.78906 25.3517 4.45312 20.0001 4.45312C14.6485 4.45312 10.3126 8.78906 10.3126 14.1406C10.3126 17.3711 11.8946 20.2344 14.3282 21.9961C14.3126 22.0039 14.297 22.0078 14.2813 22.0156C12.5313 22.7539 10.961 23.8125 9.61338 25.1641C8.2724 26.5022 7.20324 28.0874 6.46494 29.832C5.73964 31.5401 5.34846 33.3713 5.3126 35.2266C5.31156 35.2683 5.31887 35.3097 5.3341 35.3486C5.34934 35.3874 5.3722 35.4228 5.40132 35.4526C5.43044 35.4825 5.46524 35.5062 5.50368 35.5224C5.54211 35.5386 5.58339 35.5469 5.6251 35.5469H7.96885C8.14072 35.5469 8.27744 35.4102 8.28135 35.2422C8.35947 32.2266 9.57041 29.4023 11.711 27.2617C13.9259 25.0469 16.8673 23.8281 20.0001 23.8281C23.1329 23.8281 26.0743 25.0469 28.2892 27.2617C30.4298 29.4023 31.6407 32.2266 31.7188 35.2422C31.7228 35.4141 31.8595 35.5469 32.0313 35.5469H34.3751C34.4168 35.5469 34.4581 35.5386 34.4965 35.5224C34.535 35.5062 34.5698 35.4825 34.5989 35.4526C34.628 35.4228 34.6509 35.3874 34.6661 35.3486C34.6813 35.3097 34.6886 35.2683 34.6876 35.2266C34.6485 33.3594 34.2618 31.543 33.5353 29.8281ZM20.0001 20.8594C18.2071 20.8594 16.5196 20.1602 15.2501 18.8906C13.9806 17.6211 13.2813 15.9336 13.2813 14.1406C13.2813 12.3477 13.9806 10.6602 15.2501 9.39062C16.5196 8.12109 18.2071 7.42188 20.0001 7.42188C21.7931 7.42188 23.4806 8.12109 24.7501 9.39062C26.0196 10.6602 26.7188 12.3477 26.7188 14.1406C26.7188 15.9336 26.0196 17.6211 24.7501 18.8906C23.4806 20.1602 21.7931 20.8594 20.0001 20.8594Z" fill="#344F7A" />
        </svg></Box>
        <Skeleton height={36} width={250} style={{ marginLeft: '12px' }} />
      </Flex>
      <Flex flex={1} flexDirection={'column'} justifyContent='center' alignItems={'center'} >
        <LoadingMessages style={{ maxWidth: '50%' }} maxWidth='50%' />
      </Flex>
    </Container>
  )
  if (!dataPatient || !dataPatient.getProviderPatientById) {
    return (<Container flexDirection={'column'}
      justifyContent='center'
      alignItems={'center'}
      style={{ width: '100%', minHeight: '100%', overflow: 'hidden' }} >
      <Flex mt={`${Constants.OUTLETS_PADDING_TOP}px`} style={{ position: 'relative', justifyContent: 'center' }}>
        <Flex style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          justifyContent: 'center',
          alignItems: 'center',
        }}>
          <Image src={doctorIcon} style={{ marginTop: '-180px', opacity: 0.5, marginRight: '-100px' }} width='80px' height='80px' />
        </Flex>
        <PatientNotFoundSvg maxWidth={'50%'} />
      </Flex>
      <Text fontSize={'36px'} fontWeight={600}>Ups!... no results found</Text>
      <Text fontSize={'24px'}>Patient {id} does not exist</Text>
    </Container>)
  }
  let patientName = `${dataPatient?.getProviderPatientById?.firstname} ${dataPatient?.getProviderPatientById?.lastname}`
  if (Constants.IS_SCRAMBLING_MODE) {
    patientName = `${getMockedFirstName()} ${getMockedLastName()}`
  }
  return (
    <Flex id='aallm' flexDirection={'row'} style={{ width: '100%', minHeight: '100%', overflow: 'hidden' }} px={2}>
      <Flex mt={`${Constants.OUTLETS_PADDING_TOP}px`} flexDirection={'column'} style={{ width: '100%' }}>
        <Flex mb={[2, 4, 4]} flexDirection={['column', 'row', 'row']}>
          {/* <Box display={['none!important', 'flex !important', 'flex !important']}><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M33.5353 29.8281C32.7984 28.0827 31.729 26.4973 30.3868 25.1602C29.0487 23.8192 27.4635 22.75 25.7188 22.0117C25.7032 22.0039 25.6876 22 25.672 21.9922C28.1056 20.2344 29.6876 17.3711 29.6876 14.1406C29.6876 8.78906 25.3517 4.45312 20.0001 4.45312C14.6485 4.45312 10.3126 8.78906 10.3126 14.1406C10.3126 17.3711 11.8946 20.2344 14.3282 21.9961C14.3126 22.0039 14.297 22.0078 14.2813 22.0156C12.5313 22.7539 10.961 23.8125 9.61338 25.1641C8.2724 26.5022 7.20324 28.0874 6.46494 29.832C5.73964 31.5401 5.34846 33.3713 5.3126 35.2266C5.31156 35.2683 5.31887 35.3097 5.3341 35.3486C5.34934 35.3874 5.3722 35.4228 5.40132 35.4526C5.43044 35.4825 5.46524 35.5062 5.50368 35.5224C5.54211 35.5386 5.58339 35.5469 5.6251 35.5469H7.96885C8.14072 35.5469 8.27744 35.4102 8.28135 35.2422C8.35947 32.2266 9.57041 29.4023 11.711 27.2617C13.9259 25.0469 16.8673 23.8281 20.0001 23.8281C23.1329 23.8281 26.0743 25.0469 28.2892 27.2617C30.4298 29.4023 31.6407 32.2266 31.7188 35.2422C31.7228 35.4141 31.8595 35.5469 32.0313 35.5469H34.3751C34.4168 35.5469 34.4581 35.5386 34.4965 35.5224C34.535 35.5062 34.5698 35.4825 34.5989 35.4526C34.628 35.4228 34.6509 35.3874 34.6661 35.3486C34.6813 35.3097 34.6886 35.2683 34.6876 35.2266C34.6485 33.3594 34.2618 31.543 33.5353 29.8281ZM20.0001 20.8594C18.2071 20.8594 16.5196 20.1602 15.2501 18.8906C13.9806 17.6211 13.2813 15.9336 13.2813 14.1406C13.2813 12.3477 13.9806 10.6602 15.2501 9.39062C16.5196 8.12109 18.2071 7.42188 20.0001 7.42188C21.7931 7.42188 23.4806 8.12109 24.7501 9.39062C26.0196 10.6602 26.7188 12.3477 26.7188 14.1406C26.7188 15.9336 26.0196 17.6211 24.7501 18.8906C23.4806 20.1602 21.7931 20.8594 20.0001 20.8594Z" fill="#344F7A" />
          </svg></Box> */}
          <Box display={['none!important', 'flex !important', 'flex !important']}>
            {!!dataPatient && dataPatient.getProviderPatientById && dataPatient.getProviderPatientById.b2b ? (
              <svg style={{ cursor: 'pointer' }} onClick={() => setIsShowB2B(true)} width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 14C14.764 14 17 11.762 17 9C17 6.238 14.764 4 12 4C9.236 4 7 6.238 7 9C7 11.762 9.236 14 12 14ZM12 6C13.654 6 15 7.346 15 9C15 10.654 13.654 12 12 12C10.346 12 9 10.654 9 9C9 7.346 10.346 6 12 6ZM20 15C20.663 15 21.2989 14.7366 21.7678 14.2678C22.2366 13.7989 22.5 13.163 22.5 12.5C22.5 11.837 22.2366 11.2011 21.7678 10.7322C21.2989 10.2634 20.663 10 20 10C19.337 10 18.7011 10.2634 18.2322 10.7322C17.7634 11.2011 17.5 11.837 17.5 12.5C17.5 13.163 17.7634 13.7989 18.2322 14.2678C18.7011 14.7366 19.337 15 20 15ZM20 11C20.827 11 21.5 11.673 21.5 12.5C21.5 13.327 20.827 14 20 14C19.173 14 18.5 13.327 18.5 12.5C18.5 11.673 19.173 11 20 11ZM20 15.59C18.669 15.59 17.668 15.996 17.083 16.559C15.968 15.641 14.205 15 12 15C9.734 15 8.005 15.648 6.908 16.564C6.312 15.999 5.3 15.589 4 15.589C1.812 15.589 0.5 16.68 0.5 17.772C0.5 18.317 1.812 18.864 4 18.864C4.604 18.864 5.146 18.813 5.623 18.731L5.583 19.001C5.583 20.001 7.988 21.001 12 21.001C15.762 21.001 18.417 20.001 18.417 19.001L18.396 18.746C18.859 18.819 19.392 18.864 20 18.864C22.051 18.864 23.5 18.317 23.5 17.772C23.5 16.68 22.127 15.59 20 15.59ZM4 17.863C2.691 17.863 1.932 17.656 1.583 17.509C1.822 17.104 2.586 16.589 4 16.589C5.107 16.589 5.837 16.94 6.208 17.295L5.973 17.639C5.521 17.758 4.865 17.863 4 17.863ZM12 19C9.837 19 8.499 18.688 7.816 18.439C8.337 17.761 9.734 17 12 17C14.169 17 15.59 17.761 16.148 18.425C15.393 18.695 13.986 19 12 19ZM20 17.863C19.086 17.863 18.454 17.76 18.027 17.65C17.9526 17.5197 17.8698 17.3944 17.779 17.275C18.135 16.93 18.85 16.59 20 16.59C21.324 16.59 22.141 17.091 22.404 17.501C22.014 17.664 21.199 17.863 20 17.863ZM4 15C4.66304 15 5.29893 14.7366 5.76777 14.2678C6.23661 13.7989 6.5 13.163 6.5 12.5C6.5 11.837 6.23661 11.2011 5.76777 10.7322C5.29893 10.2634 4.66304 10 4 10C3.33696 10 2.70107 10.2634 2.23223 10.7322C1.76339 11.2011 1.5 11.837 1.5 12.5C1.5 13.163 1.76339 13.7989 2.23223 14.2678C2.70107 14.7366 3.33696 15 4 15ZM4 11C4.827 11 5.5 11.673 5.5 12.5C5.5 13.327 4.827 14 4 14C3.173 14 2.5 13.327 2.5 12.5C2.5 11.673 3.173 11 4 11Z" fill="#344F7A" />
              </svg>
            ) : (
              <svg width="32" height="32" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M33.5353 29.8281C32.7984 28.0827 31.729 26.4973 30.3868 25.1602C29.0487 23.8192 27.4635 22.75 25.7188 22.0117C25.7032 22.0039 25.6876 22 25.672 21.9922C28.1056 20.2344 29.6876 17.3711 29.6876 14.1406C29.6876 8.78906 25.3517 4.45312 20.0001 4.45312C14.6485 4.45312 10.3126 8.78906 10.3126 14.1406C10.3126 17.3711 11.8946 20.2344 14.3282 21.9961C14.3126 22.0039 14.297 22.0078 14.2813 22.0156C12.5313 22.7539 10.961 23.8125 9.61338 25.1641C8.2724 26.5022 7.20324 28.0874 6.46494 29.832C5.73964 31.5401 5.34846 33.3713 5.3126 35.2266C5.31156 35.2683 5.31887 35.3097 5.3341 35.3486C5.34934 35.3874 5.3722 35.4228 5.40132 35.4526C5.43044 35.4825 5.46524 35.5062 5.50368 35.5224C5.54211 35.5386 5.58339 35.5469 5.6251 35.5469H7.96885C8.14072 35.5469 8.27744 35.4102 8.28135 35.2422C8.35947 32.2266 9.57041 29.4023 11.711 27.2617C13.9259 25.0469 16.8673 23.8281 20.0001 23.8281C23.1329 23.8281 26.0743 25.0469 28.2892 27.2617C30.4298 29.4023 31.6407 32.2266 31.7188 35.2422C31.7228 35.4141 31.8595 35.5469 32.0313 35.5469H34.3751C34.4168 35.5469 34.4581 35.5386 34.4965 35.5224C34.535 35.5062 34.5698 35.4825 34.5989 35.4526C34.628 35.4228 34.6509 35.3874 34.6661 35.3486C34.6813 35.3097 34.6886 35.2683 34.6876 35.2266C34.6485 33.3594 34.2618 31.543 33.5353 29.8281ZM20.0001 20.8594C18.2071 20.8594 16.5196 20.1602 15.2501 18.8906C13.9806 17.6211 13.2813 15.9336 13.2813 14.1406C13.2813 12.3477 13.9806 10.6602 15.2501 9.39062C16.5196 8.12109 18.2071 7.42188 20.0001 7.42188C21.7931 7.42188 23.4806 8.12109 24.7501 9.39062C26.0196 10.6602 26.7188 12.3477 26.7188 14.1406C26.7188 15.9336 26.0196 17.6211 24.7501 18.8906C23.4806 20.1602 21.7931 20.8594 20.0001 20.8594Z" fill="#344F7A" />
              </svg>
            )}
          </Box>
          <PageTopBar isMessagesExpanded={false}
            HcStickyNoteRef={HcStickyNoteRef}
            createHcSticky={() => setEditHcSticky(true)}
            dataHealthcoachStickyNote={dataHealthcoachStickyNote}
            data={data}
            dataPatient={dataPatient}
            patientName={patientName}
            chartAlertRef={chartAlertRef}
            isMinimized={true}
            createChartAlert={() => setIsEditAlert(true)} />

        </Flex>
        {/* <TabsContainer mb={4}> */}
        <Flex minWidth={['1000px', '100%', '100%']} justifyContent={'flex-end'} mb={3}>
          <Select
            isSearchable={false}
            styles={ReactSelectStyles.initialStyles}
            options={optionsView as any}
            value={optionsView.find(x => x.value === selectedView)}
            onChange={(option: any) => {
              if (!option) return
              setselectedView(option.value as 'Labs' | 'keyInfos' | 'symptoms' | 'courses' | 'surveys')
            }} />

        </Flex>

        <Flex flex={1} paddingBottom={'12px'}>
          {selectedView === 'Labs' && (
            <Flex flex={1} id='ttt' flexDirection={'column'} mr={[0]} width='100%' height={'100%'} overflow={'hidden'}>
              <LabsAndVisits id={id} isMinimized={true} />
            </Flex>
          )}
          {selectedView === 'keyInfos' && (
            <Flex flex={1} id='ttt' flexDirection={'column'} mr={[0]} width='100%' height={'100%'} overflow={'hidden'}>
              <KeyInfos id={id} isMinimized={true} />
            </Flex>
          )}
          {selectedView === 'surveys' && (
            <>
              <Flex flex={1} id='ttt' flexDirection={'column'} mr={[0]} width='100%' height={'100%'} overflow={'hidden'}>
                {!id ? null :
                  <Surveys id={id} isMinimized={true} />}
              </Flex>
            </>
          )}
          {selectedView === 'symptoms' && (
            <Flex flex={1} id='there' flexDirection={'column'} mr={[0]} width='100%' height={'100%'} overflow={'hidden'} mt={3}>
              <SymptomsAndFood id={id} isMinimized />
            </Flex>
          )}
          {selectedView === 'courses' && (
            <>
              <Flex flex={1} id='ttt' flexDirection={'column'} mr={[0, 0, 4]} width='100%' overflow={'hidden'}>
                <Flex maxHeight={'calc(100vh - 208px)'}>
                  <LastCourses id={id} isMinimized isMobileUser={dataPatient.getProviderPatientById.isMobileUser} />
                </Flex>
              </Flex>
            </>
          )}
        </Flex>

        <Flex display={['none', 'initial', 'initial']}>

          {((data || {}).getProviderPatientChartAlert || {}).notetext && (
            <ReactTooltip id='chartAlertTooltip'
              clickable={true} isCapture
              globalEventOff={"click scroll"} className='chartAlertTooltip-color' place='bottom' border={true} effect={'solid'}
              backgroundColor='#fef7d9' borderColor='#ffe781' arrowColor='#fef7d9'>
              <Flex flexDirection={'column'} minWidth={['50px', '200px', '200px']} paddingY={3} onClick={() => {
                ReactTooltip.rebuild()
                ReactTooltip.hide(chartAlertRef.current)
              }}>
                <Flex>
                  <Flex flexDirection={'column'} flex={1}>
                    {((data || {}).getProviderPatientChartAlert || {}).notetext?.split('\n').map(x => {
                      return <Text color={'#344F7A'} fontSize='14px'>⊛ {x}</Text>
                    })}
                  </Flex>
                  <Text fontWeight={300} ml={2} color={'#344F7A'} fontSize='12px' style={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={() => setIsEditAlert(true)}>Edit</Text>
                </Flex>
                <Flex flexWrap={'wrap'} mt={2}>
                  <Text mr={2} fontWeight={300} color={'#344F7A'} opacity={0.7}>{((data || {}).getProviderPatientChartAlert || {}).lastmodifiedby}</Text>
                  <Text fontWeight={300} color={'#344F7A'} opacity={0.7}>{((data || {}).getProviderPatientChartAlert || {}).lastmodified}</Text>
                </Flex>
              </Flex>
            </ReactTooltip>)}


          {((dataHealthcoachStickyNote || {}).getHealthcoachStickyNote || {}).note && (
            <ReactTooltip id='HcStickyNoteRefTooltip'
              clickable={true} isCapture
              globalEventOff={"click scroll"} className='chartAlertTooltip-color' place='bottom' border={true} effect={'solid'}
              backgroundColor='#d9fee2' borderColor='#81ffad' arrowColor='#d9fee3'>
              <Flex flexDirection={'column'} minWidth={['50px', '200px', '200px']} paddingY={3} onClick={() => {
                ReactTooltip.rebuild()
                ReactTooltip.hide(HcStickyNoteRef.current)
              }}>
                <Flex>
                  <Flex flexDirection={'column'} flex={1}>
                    {((dataHealthcoachStickyNote || {}).getHealthcoachStickyNote || {}).note?.split('\n').map(x => {
                      return <Text color={'#344F7A'} fontSize='14px'>⊛ {x}</Text>
                    })}
                  </Flex>
                  <Text fontWeight={300} ml={2} color={'#344F7A'} fontSize='12px' style={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={() => setEditHcSticky(true)}>Edit</Text>
                </Flex>
              </Flex>
            </ReactTooltip>)}
        </Flex>
      </Flex>
      {!!isEditAlert && (
        <Modal
          isOpen={true}
          onBackgroundClick={() => {
            setIsEditAlert(false)
          }}
          onEscapeKeydown={() => {
            setIsEditAlert(false)
          }}
        >
          <SpecialModalBackground
            onClick={() => {
              setIsEditAlert(false)
            }}
          >
            <Box
              style={{
                margin: '0 auto',
                alignSelf: 'center',
                borderRadius: '20px',
                position: 'relative',
                background: 'linear-gradient(180deg, #BBD4ED 0%, #FDF5F2 100%)',
                padding: '24px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                maxWidth: '95vw',
                minWidth: 'initial',
                maxHeight: '95vh',
                overflowY: 'hidden',
              }}
              onClick={(e) => {
                // e.preventDefault();
                e.stopPropagation();
              }}
            >
              <Flex flex={1} flexDirection={'column'} width={'800px'} style={{ overflowY: 'auto' }}>
                <Formik
                  initialValues={{
                    alert: ''
                  }}
                  isInitialValid={() => {
                    return true
                  }}
                  onSubmit={async (values) => {
                    await appendChartAlert({
                      variables: {
                        athenaId: id,
                        noteToAdd: values.alert
                      }
                    })
                    refetchChartAlerts()
                    setIsEditAlert(false)
                  }}
                >
                  {({ touched, errors, isValid, values, submitForm }) => {
                    return (
                      <>
                        <Form>
                          <Heading textAlign={'center'} mb={4}>Add New Sticky Note Entry</Heading>
                          <FormField mb={3} error={touched.alert && errors.alert}>
                            <TextArea style={{ minHeight: '200px', maxHeight: '200px' }} name="alert" id="input_name" />
                          </FormField>
                          <Flex alignItems="center" flexDirection="row" justifyContent={'center'}>
                            <Button variant="outline" width={'100px'} mr={3} type="button" id="btn_login" onClick={() => setIsEditAlert(false)}>
                              Cancel
                            </Button>
                            <Button disabled={!isValid || !!loadingAppendChartAlert} variant="primary" width={'100px'} type="button" id="btn_login" onClick={submitForm}>
                              Save
                            </Button>
                          </Flex>
                        </Form>

                      </>
                    );
                  }}
                </Formik>
              </Flex>
            </Box>
          </SpecialModalBackground>
        </Modal>
      )}
      {!!isEditHcSticky && (
        <Modal
          isOpen={true}
          onBackgroundClick={() => {
            setEditHcSticky(false)
          }}
          onEscapeKeydown={() => {
            setEditHcSticky(false)
          }}
        >
          <SpecialModalBackground
            onClick={() => {
              setEditHcSticky(false)
            }}
          >
            <Box
              style={{
                margin: '0 auto',
                alignSelf: 'center',
                borderRadius: '20px',
                position: 'relative',
                background: 'linear-gradient(180deg, #BBD4ED 0%, #FDF5F2 100%)',
                padding: '24px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                maxWidth: '95vw',
                minWidth: 'initial',
                maxHeight: '95vh',
                overflowY: 'hidden',
              }}
              onClick={(e) => {
                // e.preventDefault();
                e.stopPropagation();
              }}
            >
              <Flex flex={1} flexDirection={'column'} width={'800px'} style={{ overflowY: 'auto' }}>
                <Formik
                  initialValues={{
                    alert: dataHealthcoachStickyNote?.getHealthcoachStickyNote?.note
                  }}
                  isInitialValid={() => {
                    return true
                  }}
                  onSubmit={async (values) => {
                    await addHcStickyNote({
                      variables: {
                        athenaId: id,
                        note: values.alert
                      }
                    })
                    refetchHealthcoachStickyNote()
                    setEditHcSticky(false)
                  }}
                >
                  {({ touched, errors, isValid, values, submitForm }) => {
                    return (
                      <>
                        <Form>
                          <Heading textAlign={'center'} mb={4}>Add New HC Sticky Note Entry</Heading>
                          <FormField mb={3} error={touched.alert && errors.alert}>
                            <TextArea style={{ minHeight: '200px', maxHeight: '200px' }} name="alert" id="input_name" />
                          </FormField>
                          <Flex alignItems="center" flexDirection="row" justifyContent={'center'}>
                            <Button variant="outline" width={'100px'} mr={3} type="button" id="btn_login" onClick={() => setEditHcSticky(false)}>
                              Cancel
                            </Button>
                            <Button disabled={!isValid || !!loadingAddHcStickyNote} variant="primary" width={'100px'} type="button" id="btn_login" onClick={submitForm}>
                              Save
                            </Button>
                          </Flex>
                        </Form>

                      </>
                    );
                  }}
                </Formik>
              </Flex>
            </Box>
          </SpecialModalBackground>
        </Modal>
      )}

      {!!isShowB2B && dataPatient && dataPatient.getProviderPatientById && dataPatient.getProviderPatientById.b2b && (
        <Modal
          isOpen={true}
          onBackgroundClick={() => {
            setIsShowB2B(false)
          }}
          onEscapeKeydown={() => {
            setIsShowB2B(false)
          }}
        >
          <SpecialModalBackground
            onClick={() => {
              setIsShowB2B(false)
            }}
          >
            <Box
              style={{
                margin: '0 auto',
                alignSelf: 'center',
                borderRadius: '20px',
                position: 'relative',
                background: 'linear-gradient(180deg, #BBD4ED 0%, #FDF5F2 100%)',
                padding: '24px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                maxWidth: '95vw',
                minWidth: 'initial',
                maxHeight: '95vh',
                overflowY: 'hidden',
              }}
              onClick={(e) => {
                // e.preventDefault();
                e.stopPropagation();
              }}
            >
              <Flex flex={1} flexDirection={'column'} width={'800px'} style={{ overflowY: 'auto' }}>
                <Heading mb={4}>B2B User</Heading>

                <Text mb={2}>
                  Company:
                  <span style={{ fontWeight: 600 }}>{` ${dataPatient.getProviderPatientById.b2b.company}`}</span>
                </Text>
                <Text mb={2}>
                  Needs Admin Approval:
                  <span style={{ fontWeight: 600 }}>{` ${dataPatient.getProviderPatientById.b2b.needAdminApproval ? 'Yes' : 'No'}`}</span>
                </Text>
                <Text mb={2}>
                  Activation Date:
                  <span style={{ fontWeight: 600 }}>{` ${dataPatient.getProviderPatientById.b2b.activationDate ? moment(dataPatient.getProviderPatientById.b2b.activationDate).format('MM/DD/YYYY') : 'Not Activated'}`}</span>
                </Text>
                <Text mb={2}>
                  Is Active:
                  <span style={{ fontWeight: 600 }}>{` ${dataPatient.getProviderPatientById.b2b.isActive ? 'Yes' : 'No'}`}</span>
                </Text>
                <Text mb={2}>
                  Verification sent:
                  <span style={{ fontWeight: 600 }}>{` ${dataPatient.getProviderPatientById.b2b.verificationSent ? 'Yes' : 'No'}`}</span>
                </Text>
                {dataPatient.getProviderPatientById.b2b.verificationSentDate && (
                  <Text mb={2}>
                    Verification sent date:
                    <span style={{ fontWeight: 600 }}>{` ${moment(dataPatient.getProviderPatientById.b2b.verificationSentDate).format('MM/DD/YYYY')}`}</span>
                  </Text>
                )}
                {dataPatient.getProviderPatientById?.b2b?.companyId && (
                  <>
                    <B2BFreenessModal patient={dataPatient.getProviderPatientById} />

                    <B2BRestrictionsModal patient={dataPatient.getProviderPatientById} />
                  </>
                )}
                <Button alignSelf={'center'} mt={4} variant={'primary'} onClick={() => setIsShowB2B(false)}>Close</Button>
              </Flex>
            </Box>
          </SpecialModalBackground>
        </Modal>
      )}
    </Flex>
  )
}

const Patient: React.FC<{
  isMinimized?: boolean
}> = ({ isMinimized }) => {
  let { id } = useParams();

  if (!id) return null
  if (!!isMinimized) {
    return (
      <PatientInnerMinimized id={id} />
    )
  }
  return (
    <PatientInner id={id} />
  )
}

export const PatientEmbed: React.FC<{
  athenaId: string
}> = ({ athenaId }) => {
  return (
    <PatientInnerMinimized id={athenaId} />
  )
}

export default Patient